/** Exclusive USB DAC: set the device sample rate to the track's rate before play (extracted from TransportCommand). */
import { useMaestroStore } from '../store/maestroStore';
import { shouldRouteStickyShared } from '../utils/stickySharedFallback';

type ConnectorModule = typeof import('../lib/connector');

export async function matchUsbDacSampleRate(
  track: any,
  isTauri: boolean,
  getConnector: () => Promise<ConnectorModule>,
): Promise<void> {
  if (!isTauri || shouldRouteStickyShared(useMaestroStore.getState().discovery?.activeZone as any, track)) return; // #10426-a1: shared never sets the HAL rate (327: sync, no timeout)

  const { selectedUsbDac } = useMaestroStore.getState();
  if (!selectedUsbDac?.id) return;

  const { isExclusiveModeEnabledForDevice } = await import('../utils/usbDacNames');
  if (!isExclusiveModeEnabledForDevice(selectedUsbDac)) return;

  const sampleRate = track?.sampleRate || track?.sample_rate;
  if (!sampleRate || typeof sampleRate !== 'number') return;

  const rateHz = sampleRate < 1000 ? sampleRate * 1000 : sampleRate;
  try {
    const C = await getConnector();
    const actual = await C.setDeviceSampleRate(selectedUsbDac.id, rateHz);
    console.log(`[TCmd] USB DAC sample rate: requested ${rateHz} Hz, device set to ${actual} Hz`);
  } catch (err) {
    console.warn('[TCmd] Failed to set USB DAC sample rate:', err);
  }
}
